module.exports = __webpack_public_path__ + "img/alfattah.580b5e3c.jpg";